import React, { ComponentProps, memo } from 'react'

import styled from '@emotion/styled'

import type { Colors, Spacings } from '@surglogs-app/ui.theme'
import { getUserInitials } from '@surglogs-app/util'

import { FlexBox } from '../uiKit/components/FlexBox'
import { Text } from '../uiKit/components/Text'

const StyledBox = styled(FlexBox, {
  shouldForwardProp: (prop) =>
    !['color', 'size', 'rounded', 'disabled'].includes(prop),
})<{ size: Spacings; rounded: boolean; disabled?: boolean }>`
  --size: ${({ theme, size }) => theme.ui.spacings[size]};
  --min-icon: ${({ theme }) => theme.ui.spacings.lg};

  align-items: center;
  justify-content: center;
  width: var(--size);
  height: var(--size);
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  border-radius: ${({ theme, rounded, bra = 'sm' }) =>
    rounded ? '50%' : theme.ui.spacings[bra]};
`

interface UserInitialsBoxProps
  extends Omit<
    ComponentProps<typeof StyledBox>,
    'size' | 'color' | 'rounded' | 'variant'
  > {
  color?: Colors
  size: Spacings
  rounded?: boolean
  disabled?: boolean
  name: string
}

export const UserInitialsBox = memo(
  ({
    size,
    rounded = false,
    bra = 'sm',
    name,
    color = 'white.100',
    disabled = false,
    ...rest
  }: UserInitialsBoxProps) => {
    const initial = getUserInitials(name)

    return (
      <StyledBox {...{ size, rounded, bra, disabled, ...rest }}>
        <Text
          {...{
            size: 'xxs',
            bold: true,
            color,
          }}>
          {initial}
        </Text>
      </StyledBox>
    )
  },
)
